import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
        { type: 'required', message: 'Please provide a phone number' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    AddressLine1: {
      validations: [
        { type: 'required', message: 'Please fill in required field' }
      ]
    },
    City: {
      validations: [
        { type: 'required', message: 'Please provide a city' },
      ]
    },
    State: {
      validations: [
        { type: 'required', message: 'Please provide a province' },
      ]
    },
    Postal: {
      validations: [
        { type: 'required', message: 'Please fill in required field' },
        { type: 'maxLength', maxLength: 6, message: 'Enter 6 characters with no spaces' },
      ]
    },
    SiteAddress: {
        validations: []
      },
      eventDate: {
        validations: [
          { type: 'dateinfuture', message: 'Event date must be in the future' },
          { type: 'required', message: 'Please fill in required field' }
        ]
      },
      plannedguestcount: {
        validations: [
          { type: 'required', message: 'Please fill in required field' }
        ]
      },
      SalesRep: {
        validations: [
          { type: 'required', message: 'Please fill in required field' }
        ]
    },
    Reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telNumber'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Mailing Address:*',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:*',
            mapping: 'City'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Province:*',
            mapping: 'State'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Postal Code:* Enter 6 characters with No Spaces',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address of Event:',
            mapping: 'SiteAddress'
        }
      ]
    },
    {
      fields: [
        {
          type: 'date-picker',
          size: 'Medium',
          label: 'Event Date:*',
          mapping: 'eventDate'
        },
        {
          type: 'text',
          size: 'Medium',
          label: 'Expected Number of Guests:* (Enter 1 or more)',
          mapping: 'plannedguestcount'
        }
      ]
    },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What is the closest Freson Bros. store to your event?:*',
            options: [
              { label: '01 - Hinton Valley', value: '01 - Hinton Valley' },
              { label: '02 - Fairview', value: '02 - Fairview' },
              { label: '03 - Stony Plain', value: '03 - Stony Plain' },
              { label: '04 - Hanna', value: '04 - Hanna' },
              { label: '05 - High Prairie', value: '05 - High Prairie' },
              { label: '06 - Hinton Hill', value: '06 - Hinton Hill' },
              { label: '07 - Manning', value: '07 - Manning' },
              { label: '09 - Grande Prairie', value: '09 - Grande Prairie' },
              { label: '11 - Valleyview', value: '11 - Valleyview' },
              { label: '12 - Barrhead', value: '12 - Barrhead' },
              { label: '13 - Fox Creek', value: '13 - Fox Creek' },
              { label: '14 - Drumheller', value: '14 - Drumheller' },
              { label: '15 - Peace River', value: '15 - Peace River' },
              { label: '16 - Fort Saskatchewan', value: '16 - Fort Saskatchewan' },
              { label: '17 - Edmonton Rabbit Hill', value: '17 - Edmonton Rabbit Hill' },
              { label: '18 - Sundre', value: '18 - Sundre' },
              { label: '19 - Edmonton Glenora', value: '19 - Edmonton Glenora' },
            ],
            mapping: 'SalesRep'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:',
            options: [
              { label: 'Repeat Customer', value: 'Repeat Customer' },
              { label: 'Referral', value: 'Referral' },
              { label: 'Wedding Fair', value: 'Wedding Fair' },
              { label: 'cateringbyfreson.com', value: 'cateringbyfreson.com' },
              { label: 'Social Media', value: 'Social Media' },
              { label: 'Email', value: 'Email' },
              { label: 'Online Ad', value: 'Online Ad' },
              { label: 'Television', value: 'Television' },
              { label: 'Magazine', value: 'Magazine' },
              { label: 'Flyer', value: 'Flyer' },
              { label: 'Podcast', value: 'Podcast' },
              { label: 'Google Search', value: 'Google Search' },
              { label: 'Freson Bros. Store', value: 'Freson Bros. Store' },
              { label: 'Outdoor Sign', value: 'Outdoor Sign' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional information:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Freson Bros Contact Form',
    formId: '2039',
    clientKey: '787AB333-3067-45FF-B9FC-A4E12982081F',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://cateringbyfreson.com/thankyou/',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
